import { Team } from '../../types/team/team';

const defaultTeam:Team = {
    "id": "",
    "name" : "",
    "users" : []
}
export default defaultTeam;